import { FetchTargetBadge, FetchTargetBadgeVariables } from "_graphql/queries/__generated__/fetchTargetBadge";

import { FETCH_TARGET_BADGE } from "_graphql/visal/queries/target-badge";
import { useQuery } from "@apollo/client";

// export interface FetchTargetBadgeResponse {
//   fetchTargetBadge: TargetBadge;
// }



export const useTargetBadge = ({ badgeId }: { badgeId: string }) => {
  const { data, loading, error, refetch } = useQuery<
    FetchTargetBadge,
    FetchTargetBadgeVariables
  >(FETCH_TARGET_BADGE, {
    variables: {
      target_badge_id: badgeId,
    },
    fetchPolicy: "network-only",
    skip: !badgeId,
  });

  return {
    badge: data?.fetchTargetBadge || null,
    loading,
    error,
    refetch,
  };
};
